import React from 'react';
import { BiometricDatapointRecord } from 'services/biometricsService';
import { buildLastSevenDays } from 'utils/dateUtils';

const DAYS_PER_WINDOW = 7;

// Matches mobile: a window is always 7 calendar days, the current one ending today. The member
// pages back 7 days at a time, so a week without readings shows an empty chart. `pageIndex`
// counts back from the current window (0 = current).
export const useChartReadingWindows = (datapoints: BiometricDatapointRecord[]) => {
  const [pageIndex, setPageIndex] = React.useState(0);

  const earliestReadingDay = React.useMemo(
    () =>
      datapoints.reduce<string | null>((earliest, point) => {
        const day = point.userLocalDateCaptured.slice(0, 10);
        return earliest === null || day < earliest ? day : earliest;
      }, null),
    [datapoints],
  );

  const days = React.useMemo(() => {
    const windowEnd = new Date();
    windowEnd.setDate(windowEnd.getDate() - pageIndex * DAYS_PER_WINDOW);
    return buildLastSevenDays(windowEnd);
  }, [pageIndex]);

  return {
    days,
    canGoBack: earliestReadingDay !== null && earliestReadingDay < days[0],
    canGoForward: pageIndex > 0,
    goBack: () => setPageIndex((current) => current + 1),
    goForward: () => setPageIndex((current) => current - 1),
  };
};
